module.exports = __webpack_public_path__ + "assets/img/24.a99f72f7.png";